/**
 * Skeleton loader for Pickup Details component
 * Shows layout while restaurant/cart data is loading
 */
export function PickupDetailsSkeleton() {
  return (
    <div className="mb-8 p-6 bg-gray-50 rounded-2xl space-y-4 motion-safe:animate-pulse">
      {/* Title skeleton */}
      <div className="h-5 w-32 bg-gray-200 rounded" />

      {/* Address skeleton */}
      <div className="space-y-2">
        <div className="h-4 w-48 bg-gray-200 rounded" />
        <div className="h-4 w-56 bg-gray-200 rounded" />
      </div>

      {/* Delivery time skeleton */}
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-200 rounded-full" />
        <div className="h-4 w-40 bg-gray-200 rounded" />
      </div>
    </div>
  );
}

